import PersonOffIcon from "@mui/icons-material/PersonOff";
import { Avatar, AvatarProps } from "@mui/material";

interface AvatarWithInitialsProps {
  size?: number;
  children: string;
}

export function stringToColor(string: string) {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  return color;
}

function stringAvatar(name: string, size?: number): AvatarProps {
  const nameParts = name.split(" ");

  const firstNameInitial = nameParts[0].charAt(0);
  const lastNameInitial =
    nameParts.length > 1 ? nameParts[nameParts.length - 1].charAt(0) : "";

  const colorFromName = stringToColor(name);

  return {
    sx: {
      height: size || 32,
      width: size || 32,
      fontSize: (size || 32) / 2,
      bgcolor: name ? colorFromName : undefined,
      fontWeight: "normal",
      color: (theme) => theme.palette.getContrastText(colorFromName),
    },
    children: name ? (
      `${firstNameInitial}${lastNameInitial}`
    ) : (
      <PersonOffIcon />
    ),
  };
}

export default function AvatarWithInitials(props: AvatarWithInitialsProps) {
  return <Avatar {...stringAvatar(props.children, props.size)} />;
}
